import { EmployeeDto } from '@zorro/clients';
import { useMonolithQuery } from '@zorro/web/ui-utils';

type UseEmployeeBankAccountProps = {
  employeeId: EmployeeDto['id'];
  enabled: boolean;
};

export function useEmployeeBankAccount({
  employeeId,
  enabled,
}: UseEmployeeBankAccountProps) {
  const { data, isFetching } = useMonolithQuery({
    method: 'paymentsControllerGetEmployeeBankAccount',
    params: [employeeId],
    enabled,
  });

  return { bankAccount: data ?? null, isFetching };
}
